import { useEffect } from 'react'

export function useTitle(title: string) {
  useEffect(() => {
    window.document.title = title
  }, [title])
}
